module.exports = __webpack_public_path__ + "static/media/detail-shirt-1990.09ea3cda.png";